import Config from '../../../../lib/Config'
import { Spreadsheet } from '../../../../lib/Types'
import { SheetType } from '../Enums/SheetType'

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
})

const spreadsheetFromJson = (spreadsheet: Spreadsheet): Spreadsheet => {
  spreadsheet.data = new Map(Object.entries(spreadsheet.data))
  spreadsheet.rows = new Map(Object.entries(spreadsheet.rows))
  spreadsheet.sheet_type = SheetType.SPREADSHEET

  return spreadsheet
}

export const createSpreadsheet = async (): Promise<Spreadsheet> => {
  const response = await fetch(`${Config.API}/spreadsheets/`, {
    method: 'POST',
    headers: { ...getHeaders() },
  })

  return await response.json()
}

export const getSpreadsheet = async (id: number): Promise<Spreadsheet> => {
  const response = await fetch(`${Config.API}/spreadsheets/${id}/`, {
    method: 'GET',
    headers: { ...getHeaders() },
  })

  return spreadsheetFromJson(await response.json())
}

export const getSpreadsheets = async (): Promise<Spreadsheet[]> => {
  const response = await fetch(`${Config.API}/spreadsheets/`, {
    headers: getHeaders(),
  })

  if (response.status !== 200) {
    throw response.status
  }

  const spreadsheets = (await response.json()) as Spreadsheet[]

  return spreadsheets.map((spreadsheet) => spreadsheetFromJson(spreadsheet))
}

export const saveSpreadsheet = async (
  spreadsheet: Spreadsheet,
): Promise<boolean> => {
  const payload = {
    ...spreadsheet,
    rows: Object.fromEntries(spreadsheet.rows),
    data: Object.fromEntries(spreadsheet.data),
  }

  await fetch(`${Config.API}/spreadsheets/${spreadsheet.id}/`, {
    method: 'PATCH',
    headers: {
      ...getHeaders(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })

  return true
}
